// Mail drawer toggles — the el.call-addressable open/close/toggle of the
// docked MailOverlay, mirroring chat's collab/drawer.js
// (toggleChatDrawer / openChatDrawer / closeChatDrawer). They ride
// functions/eagerSlice.js so any route can call them BEFORE the mail context
// folds (like chat's openChatFromToast).
//
// The overlay itself lives in the lazily-folded mail context (the shell's
// MailOverlaySlot is filled by ensureMailContext — workspace/functions/
// mailFold.js), so OPENING asks the shell to fold first when a caller reaches
// these through `el.call` (`this` is the element). A bare `openMailDrawer(root)`
// call with no element flips the flag only, exactly like chat's helpers.
//
// Cross-overlay exclusion (closing the Messenger / notifications / assistant
// when Mail opens) is the header button's job through headerOverlayPatch —
// these only own the flag.
const _kickDrawerData = (el) => {
  // Post-fold the full function barrel is registered; the drawer list needs
  // the stream + the unified-inbox first page (MAIL-UI-READ-1). Guarded: on
  // a pre-P1 registry (or a failed fold) the drawer still opens empty.
  if (!el || typeof el.call !== 'function') return
  try {
    el.call('subscribeMailStream')
    el.call('loadMailThreads')
  } catch (_) {}
}

export const openMailDrawer = async function (root) {
  const r = root || (this && this.state && this.state.root)
  if (!r) return
  if (this && typeof this.call === 'function') {
    const ok = await this.call('ensureMailContext')
    if (ok === false) return
  }
  r.update({ _mailDrawerOpen: true })
  _kickDrawerData(this)
}

export const closeMailDrawer = function (root) {
  const r = root || (this && this.state && this.state.root)
  if (!r) return
  r.update({ _mailDrawerOpen: false })
}

export const toggleMailDrawer = async function (root) {
  const r = root || (this && this.state && this.state.root)
  if (!r) return
  if (r._mailDrawerOpen) {
    r.update({ _mailDrawerOpen: false })
    return
  }
  if (this && typeof this.call === 'function') {
    const ok = await this.call('ensureMailContext')
    if (ok === false) return
  }
  r.update({ _mailDrawerOpen: true })
  _kickDrawerData(this)
}
